/**
  * Add basic tab functionality with material design-like mobile focusing for nav buttons on mobile.
  */
const init = () => {
  const tabbedDetailsContainers = document.querySelectorAll('.tabbed-details');

  tabbedDetailsContainers.forEach(container => {
    const tabNav = container.querySelectorAll('.tabbed-details__nav');
    const firstTabNav = container.querySelector('.tabbed-details__nav');
    const tabContents = container.querySelectorAll('.tabbed-details__tab-content');

    // Show first tab on desktop to prevent layout shift
    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 1023px)').matches && isThereNoActiveTabContent()) {
        showFirstTab();
      }
    });

    tabNav.forEach(nav => {
      nav.addEventListener('click', e => {
        // Allow closing of tab on mobile
        const n = (e.target.classList.contains('active') && window.matchMedia('(max-width: 1022px)').matches);

        if (e.target.type === 'button') {
          const tab = e.target;

          hideButtons();
          hideTabs();

          if (!n) {
            container.querySelectorAll('[data-target="' + e.target.dataset.target + '"]').forEach(tb => {
              tb.classList.add('active');
            });
            container.querySelector(`#${tab.dataset.target}`)?.classList.remove('d-none');
            container.querySelector(`#${tab.dataset.target}`)?.classList.add('active');
          }
        }
      });
    });

    // Hide all tab buttons, well actually just remove the active class
    function hideButtons() {
      container.querySelectorAll('.tabbed-details__nav button').forEach(btn => {
        btn.classList.remove('active');
      });
    }

    // Hide all tab content
    function hideTabs() {
      tabContents.forEach(tc => {
        tc.classList.add('d-none');
        tc.classList.remove('active');
      });
    }

    // Check if there is no active tab content
    function isThereNoActiveTabContent() {
      const activeTabContents = container.querySelectorAll('.tabbed-details__tab-content.active');
      return activeTabContents.length === 0;
    }

    // Show first tab on desktop to prevent layout shift
    function showFirstTab() {
      const button = firstTabNav.querySelector('button');
      container.querySelector(`#${button.dataset.target}`)?.classList.remove('d-none');
      container.querySelectorAll('[data-target="' + button.dataset.target + '"]').forEach(tb => {
        tb.classList.add('active');
      });
      container.querySelector(`#${button.dataset.target}`)?.classList.add('active');
    }

    // Open tab based on hash in URL
    function openTabFromHash() {
      const hash = window.location.hash.substring(1); // Remove the '#' from the hash
      if (hash) {
        const targetTab = container.querySelector(`#${hash}`);
        if (targetTab) {
          hideButtons();
          hideTabs();
          container.querySelectorAll(`[data-target="${hash}"]`).forEach(tb => {
            tb.classList.add('active');
          });
          targetTab.classList.remove('d-none');
          targetTab.classList.add('active');

          // Scroll to the target tab
          targetTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    // Listen for hash changes
    window.addEventListener('hashchange', openTabFromHash);

    // Open tab on page load if hash exists
    openTabFromHash();
  });
};

export default {
  init
};
